//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rectangle from './Rectangle.vue'

export default {
  components: {
    Rectangle
  },
  props: {
    routeSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    registered: function () {
      return this.getChildrenBlockByType('registered')
    },
    executed: function () {
      return this.getChildrenBlockByType('executed')
    },
    technicalTaskExecuted: function () {
      return this.getChildrenBlockByType('technicalTaskExecuted')
    },
    inWork: function () {
      return this.getChildrenBlockByType('inWork')
    },
    technicalTaskInWork: function () {
      return this.getChildrenBlockByType('technicalTaskInWork')
    },
    inWorkNoActualization: function () {
      return this.getChildrenBlockByType('inWorkNoActualization')
    }
  },
  methods: {
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.routeSource && this.routeSource.compound && this.routeSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
